var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.092,
    height: 18.514,
    viewBox: "0 0 23.092 18.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat0",
    transform: "translate(0 -50.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2544",
    "data-name": "Group 2544",
    transform: "translate(0 50.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    "data-name": "Path 4342",
    d: "M16.791,50.758H1.3a1.3,1.3,0,0,0-1.3,1.3v9.294a1.3,1.3,0,0,0,1.3,1.3h1v3.46a.545.545,0,0,0,.93.385L7.08,62.652h.771a.545.545,0,0,0,0-1.09s-1.023,0-1.034,0a.543.543,0,0,0-.348.158L3.394,64.8s0-2.724,0-2.738a.545.545,0,0,0-.542-.5H1.3a.211.211,0,0,1-.211-.211V52.058a.211.211,0,0,1,.211-.211H16.791a.211.211,0,0,1,.211.211v3.566a.545.545,0,1,0,1.089,0V52.058A1.3,1.3,0,0,0,16.791,50.758Z",
    transform: "translate(0 -50.758)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2546",
    "data-name": "Group 2546",
    transform: "translate(9.648 57.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    d: "M226.067,198.492H215.223a1.3,1.3,0,0,0-1.3,1.3v6.34a1.3,1.3,0,0,0,1.3,1.3h6.789l2.75,2.75a.545.545,0,0,0,.93-.385v-2.365h.374a1.3,1.3,0,0,0,1.3-1.3v-6.34A1.3,1.3,0,0,0,226.067,198.492Zm.211,7.64a.211.211,0,0,1-.211.211h-.919a.544.544,0,0,0-.543.5c0,.012,0,1.637,0,1.637l-1.978-1.978-.006-.006-.022-.02a.542.542,0,0,0-.359-.135h-7.014a.211.211,0,0,1-.211-.211v-6.34a.211.211,0,0,1,.211-.211h10.843a.211.211,0,0,1,.211.211Z",
    transform: "translate(-213.923 -198.492)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548",
    transform: "translate(15.826 61.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2547",
    "data-name": "Group 2547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    "data-name": "Path 4344",
    d: "M351.431,285.53a.545.545,0,1,0,.545.545A.545.545,0,0,0,351.431,285.53Z",
    transform: "translate(-350.886 -285.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2550",
    "data-name": "Group 2550",
    transform: "translate(3.544 54.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2549",
    "data-name": "Group 2549",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    d: "M89.031,130.611H79.117a.545.545,0,1,0,0,1.089h9.914a.545.545,0,1,0,0-1.089Z",
    transform: "translate(-78.572 -130.611)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2552",
    "data-name": "Group 2552",
    transform: "translate(3.544 57.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    d: "M82.879,210.465H79.117a.545.545,0,1,0,0,1.089h3.763a.545.545,0,1,0,0-1.089Z",
    transform: "translate(-78.572 -210.465)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    transform: "translate(13.294 61.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2553",
    "data-name": "Group 2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    d: "M295.3,285.53a.545.545,0,1,0,.545.545A.545.545,0,0,0,295.3,285.53Z",
    transform: "translate(-294.759 -285.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556",
    transform: "translate(18.357 61.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2555",
    "data-name": "Group 2555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    "data-name": "Path 4348",
    d: "M407.546,285.53a.545.545,0,1,0,.545.545A.545.545,0,0,0,407.546,285.53Z",
    transform: "translate(-407.001 -285.53)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4aee80dbd2fecdfe124528c464ea8e7c.svg";
export { ForwardRef as ReactComponent };